import { actions, reducer } from './reducer';
import { exportBookWatcher as saga } from './sagas';
import * as selectors from './selectors';

export const exportModel = { actions, reducer, selectors, saga };
